module.exports = __webpack_public_path__ + "static/img/p3.e93f95a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/p3.jpg
// module id = 6A/C
// module chunks = 1